import { IColunasSettingsUser } from "@app/shared/utils/validar_settings_user";

export const COLUNAS_DEFAULT_MODULE_PARCEIRO = [
  {
    module: 'PAR_CLIENTE',
    colunas: [
      {
        field: 'codigo',
        active: true,
        removable: true,
      },
      {
        field: 'nome_razao_social',
        active: true,
        removable: false,
      },
      {
        field: 'cliente.parceiro.nome_razao_social',
        active: true,
        removable: true,
      },
      {
        field: 'cliente.parceiro.cpf_cnpj',
        active: true,
        removable: true,
      },
      {
        field: 'cliente.limite_credito',
        active: true,
        removable: true,
      },
      {
        field: 'cliente.saldo_limite_credito',
        active: true,
        removable: true,
      },
      {
        field: 'cliente.parceiro.saldo_credito',
        active: true,
        removable: true,
      }
    ]
  },
  {
    module: 'PAR_FONECEDOR',
    colunas: [
      {
        field: 'codigo',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.nome_razao_social',
        active: true,
        removable: false
      },
      {
        field: 'parceiro.apelido_nome_fantasia',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.cpf_cnpj',
        active: true,
        removable: true
      }
    ]
  },
  {
    module: 'PAR_FABRICANTE',
    colunas: [
      {
        field: 'codigo',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.nome_razao_social',
        active: true,
        removable: false
      },
      {
        field: 'parceiro.cpf_cnpj',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.rg_insc_est',
        active: true,
        removable: true
      }
    ]
  },
  {
    module: 'PAR_FUNCIONARIO',
    colunas: [
      {
        field: 'codigo',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.nome_razao_social',
        active: true,
        removable: false
      },
      {
        field: 'parceiro.apelido_nome_fantasia',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.cpf_cnpj',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.user.name',
        active: true,
        removable: true
      }
    ]
  },
  {
    module: 'PAR_VENDEDOR',
    colunas: [
      {
        field: 'codigo',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.apelido_nome_fantasia',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.nome_razao_social',
        active: true,
        removable: false
      },
      {
        field: 'parceiro.cpf_cnpj',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.rg_insc_est',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.user.name',
        active: true,
        removable: true
      },
      {
        field: 'tipo',
        active: true,
        removable: true
      },
      {
        field: 'parceiro.saldo_credito',
        active: true,
        removable: true
      }
    ]
  }
] as IColunasSettingsUser[];
